import React from "react";
import CreateItems from "../CreateItems";

const Nigiri = (props) => {
    return (
        <div className="item-div">
            {CreateItems(
                "Nigiri",
                {
                    Albacore: ["white tuna", "8.95"],
                    "Ama-Ebi": ["sweet shrimp", "10.95"],
                    Ebi: ["cooked shrimp", "8.50"],
                    Escolar: ["escolar", "8.95"],
                    Hamachi: ["yellow tail", "8.95"],
                    Hokkigai: ["surf clam", "8.50"],
                    Hotate: ["scallop", "8.95"],
                    Ika: ["squid", "8.50"],
                    Ikura: ["salmon roe", "8.50"],
                    Inari: ["tofu wrap", "8.50"],
                    Kani: ["snow crab", "9.95"],
                    Maguro: ["tuna", "8.95"],
                    Masago: ["smelt roe", "8.50"],
                    Saba: ["mackerel", "8.95"],
                    Sake: ["salmon", "8.95"],
                    "Spicy Hotate": ["spicy scallop", "8.95"],
                    Tako: ["octopus", "8.50"],
                    Tamago: ["sweet egg", "8.50"],
                    Tobiko: ["flying fish roe", "8.50"],
                    Unagi: ["fresh water eel", "8.95"]
                },
                props
            )}
            <div className="nigiri-warning">
                <p style={{ color: "white" }}>
                    * Extra order: Uzura (Quail Egg).....3.00 *
                </p>
            </div>
        </div>
    );
};

export default Nigiri;
